import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * # CommonCode
 * 
 * CommonCode을 설명하세요.
 */
export const CommonCode = types
  .model("CommonCode")
  // --------------------------------------------------------------------------
  .props({
    code: types.maybeNull(types.optional(types.number, 0)),
    pcode: types.maybeNull(types.optional(types.number, 0)),
    value: types.maybeNull(types.optional(types.string, "")),
    enumValue: types.maybeNull(types.optional(types.string, "")),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model commonCode --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ICommonCode;
      (Object.keys(newProps) as TCommonCodeKeys[]).forEach((key) => {
        //@ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TCommonCode = Instance<typeof CommonCode>;
type TCommonCodeSnapshot = SnapshotOut<typeof CommonCode>

export interface ICommonCode extends TCommonCode { }
export type TCommonCodeKeys = keyof TCommonCodeSnapshot & string;
export interface ICommonCodeSnapshot extends TCommonCodeSnapshot { }
export const createCommonCode = () =>
  types.optional(CommonCode, {} as TCommonCode);

export const CommonCodeList = types.model('CommonCodeList', {
  name: types.maybeNull(types.optional(types.string, '')),
  list: types.maybeNull(types.optional(types.array(CommonCode), [])),
});
type TCommonCodeList = Instance<typeof CommonCodeList>;
export interface ICommonCodeList extends TCommonCodeList { }
export const createCommonCodeList = () =>
  types.optional(types.array(CommonCodeList), [] as TCommonCodeList[])